import { Button } from '@sede-enterprise/shell-ds-react-framework';
import { Page } from 'components/Layout/Page/Page';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_3, SPACING_4, SPACING_6 } from 'constants/theme-constants';
import { Link } from 'react-router';
import styled from 'styled-components';

const StyledErrorPage = styled.div`
  ${({ theme }) => `
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${cxTheme.spacing[SPACING_4]};
    justify-content: center;
    align-items: center;
    `}
`;

const StyledErrorPageInner = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${cxTheme.spacing[SPACING_3]};
    padding: ${cxTheme.spacing[SPACING_6]};
    border-radius: ${cxTheme.borderRadius.primaryRadius};
  `}
`;

const StyledErrorPageTitle = styled.h1`
  ${({ theme }) => {
    return `
      ${theme.heading['2'].demi};
    `;
  }}
`;

type ErrorPageProps = {
  error: any;
  resetErrorBoundary: () => void;
};

export const ErrorPage = ({ error, resetErrorBoundary }: ErrorPageProps) => {
  return (
    <Page>
      <StyledErrorPage>
        <StyledErrorPageInner>
          <StyledErrorPageTitle>Error occurred</StyledErrorPageTitle>
          <p>{JSON.stringify(error)}</p>
          <Link to="/">
            <Button type={'button'} onClick={resetErrorBoundary}>
              Head home
            </Button>
          </Link>
        </StyledErrorPageInner>
      </StyledErrorPage>
    </Page>
  );
};
